export enum AppointmentRegardingType {
	ACEP_OR_TCEP = 10009,
	DISCOVERY = 10010,
	LEAD = 4,
}
